var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
var Empty = /** @class */ (function (_super) {
    __extends(Empty, _super);
    function Empty() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Empty.prototype, "resourceText", {
        get: function () {
            var modules = this.modules;
            if (modules && modules.length > 0) {
                if (modules.length > 1) {
                    return '展位/广告位';
                }
                else {
                    return modules[0] === 'tntSpotMng' ? '展位' : '广告位';
                }
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Empty.prototype.goHandle = function () {
        if (this.modules && this.modules.length > 0) {
            var path = this.modules.includes('tntSpotMng') ? 'lhb-micro-pms/pointMng' : 'lhb-micro-pms/adsMng';
            this.$router.push(path);
        }
    };
    __decorate([
        Prop({
            type: Boolean,
            default: true,
        })
    ], Empty.prototype, "showBtn", void 0);
    __decorate([
        Prop({
            type: String,
            default: '请先添加或上架展位/广告位',
        })
    ], Empty.prototype, "emptyText", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], Empty.prototype, "modules", void 0);
    Empty = __decorate([
        Component
    ], Empty);
    return Empty;
}(Vue));
export default Empty;
